import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { formatPrice } from '../lib/format';

const ProductCard = ({ product }) => {
  const { addToCart, toggleFavorite, favorites } = useCart();
  const isFav = favorites.includes(product.id);

  return (
    <div className="group relative bg-white">
      {/* Image */}
      <Link to={`/produs/${product.slug}`} className="block relative aspect-square overflow-hidden rounded-2xl bg-neutral-50">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />

        {product.discount > 0 && (
          <span className="absolute top-3 left-3 bg-neutral-900 text-white text-[11px] font-semibold px-2.5 py-1 rounded-full">
            -{product.discount}%
          </span>
        )}

        <button
          onClick={(e) => {
            e.preventDefault();
            toggleFavorite(product.id);
          }}
          className={`absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center backdrop-blur-sm transition-colors ${
            isFav
              ? 'bg-neutral-900 text-white'
              : 'bg-white/90 text-neutral-700 hover:bg-neutral-900 hover:text-white'
          }`}
          aria-label="Adaugă la favorite"
        >
          <Heart className={`w-4 h-4 ${isFav ? 'fill-current' : ''}`} />
        </button>

        {/* Hover add to cart */}
        <button
          onClick={(e) => {
            e.preventDefault();
            addToCart(product);
          }}
          className="absolute left-3 right-3 bottom-3 bg-neutral-900 hover:bg-amber-500 text-white text-sm font-medium py-2.5 rounded-full opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 flex items-center justify-center gap-2"
        >
          <ShoppingCart className="w-4 h-4" />
          Adaugă în coș
        </button>
      </Link>

      {/* Info */}
      <div className="mt-4">
        <div className="text-[11px] uppercase tracking-[0.15em] text-neutral-500">
          {product.categoryName}
        </div>
        <Link to={`/produs/${product.slug}`}>
          <h3 className="mt-1.5 font-medium text-neutral-900 line-clamp-2 hover:text-amber-700 transition-colors leading-snug min-h-[2.75rem]">
            {product.name}
          </h3>
        </Link>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-lg font-serif font-bold text-neutral-900">
            {formatPrice(product.price)}
          </span>
          {product.oldPrice && (
            <span className="text-sm text-neutral-400 line-through">
              {formatPrice(product.oldPrice)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
